import { render, staticRenderFns } from "./bannerPopup.vue?vue&type=template&id=18c7ec90&scoped=true&"
import script from "./bannerPopup.vue?vue&type=script&lang=ts&"
export * from "./bannerPopup.vue?vue&type=script&lang=ts&"
import style0 from "./bannerPopup.vue?vue&type=style&index=0&id=18c7ec90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7ec90",
  null
  
)

export default component.exports